module.exports = __webpack_public_path__ + "static/media/calendar-date.023d4d52.svg";